import React, { useEffect, useRef, useState } from "react";
import Pencil from "../../assets/svg/Pencil";
import Clock from "../../assets/svg/Clock";
import axiosPublic from "../../axios/axiosPublic";
import useAuth from "../../hooks/useAuth";
import useLoader from "../../hooks/useLoader";

const AccountLogin = ({ isProfile }) => {
  const { login, setUser } = useAuth();
  const { setLoading } = useLoader();
  const [value, setValue] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otpSent, setOtpSent] = useState(false);

  const inputsRef = useRef([]);
  const phoneInputRef = useRef(null);

  const [seconds, setSeconds] = useState(30);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");

    // Strips only leading zeros, mid/end zeros are safe
    const sanitized = digitsOnly.replace(/^0+/, "");

    const phone = sanitized.slice(0, 10);
    setValue(phone);

    if (phone.length === 10 && !otpSent && phone[0] !== "0") {
      sendOtp(phone);
    }
  };

  const handleChangeotp = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const nextOtp = [...otp];
    nextOtp[index] = value;
    setOtp(nextOtp);

    if (value && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }

    // AUTO VERIFY WHEN ALL 6 DIGITS ENTERED
    const finalOtp = nextOtp.join("");
    if (finalOtp.length === 4) {
      verifyOtp(finalOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  // ADDED SEND OTP FUNCTION
  const sendOtp = async (phone) => {
    try {
      setLoading(true);
      setError("");

      await axiosPublic.post("/users/user-get-otp", {
        phone_number: phone,
      });

      setOtpSent(true);
      setSeconds(30);
      setOtp(["", "", "", ""]);
      setTimeout(() => {
        inputsRef.current[0]?.focus();
      }, 0);
    } catch (err) {
      setError(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (finalOtp) => {
    try {
      setLoading(true);
      setError("");

      const res = await axiosPublic.post("/users/user-verify-otp", {
        phone_number: value,
        otp: finalOtp,
      });

      // LOCALSTORAGE
      // const token = res.data?.data?.token;
      // LOCALSTORAGE
      const customer = res?.data?.data?.customer;
      // if (!token) throw new Error();

      login(customer);
      // LOCALSTORAGE
      // login(token, customer);
      // LOCALSTORAGE
    } catch (err) {
      // console.log(err?.response?.data?.message);
      setError(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!otpSent || seconds === 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [otpSent, seconds]);

  useEffect(() => {
    if (otpSent) {
      setTimeout(() => {
        inputsRef.current[0]?.focus();
      }, 0);
    } else {
      setTimeout(() => {
        phoneInputRef.current?.focus();
      }, 0);
    }
  }, [otpSent]);

  return (
    <div className="hayd-checkout-account-login-inner">
      {!otpSent && (
        <div>
          <div className="hayd-checkout-ccount-login-number-container">
            <p
              className={`text-center text-black supreme-bold  ${
                isProfile ? "text-[24px]" : "text-[18px]"
              }`}
            >
              Enter mobile number
            </p>
            <p
              className={`text-center general-sans-medium text-gray-400 ${
                isProfile ? "text-[16px] mt-[10px]" : "text-[14px] mt-[6px]"
              }`}
            >
              Provide your mobile number to continue
            </p>
          </div>

          <div className="mt-4 px-3">
            <div className="flex items-center border-1 border-gray-400 rounded-lg overflow-hidden bg-white focus-within:ring-1 focus-within:ring-blue-400">
              <div className="flex items-center gap-1 px-2 py-3 border-r bg-white">
                <span className="text-lg">🇮🇳</span>
                <span className="font-medium text-gray-600">+91</span>
              </div>

              <input
                ref={phoneInputRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={value}
                onChange={handleChange}
                placeholder="10-digit mobile number"
                className=" flex-1 px-4 py-3 text-gray-800 placeholder-gray-300 outline-none border-none general-sans-regular tracking-wide"
              />
            </div>
          </div>
        </div>
      )}

      {otpSent && (
        <div>
          <div className="hayd-checkout-ccount-login-number-container">
            <p
              className={`text-center text-black supreme-bold ${
                isProfile ? "text-[24px]" : "text-[16px]"
              }`}
            >
              Verify phone number
            </p>
            <div className="flex items-center justify-center gap-2 mt-3">
              <p
                className={`text-gray-600 general-sans-medium ${
                  isProfile ? "text-[14px]" : "text-[12px]"
                }`}
                style={{ wordSpacing: "2px" }}
              >
                Enter OTP sent to
              </p>
              <p
                className={`text-black supreme-bold ${
                  isProfile ? "text-[18px]" : "text-[16px]"
                }`}
              >
                +91 {value}
              </p>
              <button
                className="p-1.5 rounded-md border border-gray-400 text-blue-500"
                onClick={() => {
                  setOtpSent(false);
                  setValue("");
                  setOtp(["", "", "", ""]);
                }}
              >
                <Pencil size={12} />
              </button>
            </div>
          </div>
          <div className="mt-4 px-3">
            <div
              className={`flex justify-center mt-4 ${
                isProfile ? "gap-5" : "gap-3"
              }`}
            >
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputsRef.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => {
                    handleChangeotp(e.target.value, index);
                    setError("");
                  }}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className={`${
                    isProfile ? "h-14 w-14" : "h-10 w-10"
                  } text-center rounded-lg outline-none ring-1 ring-blue-100 focus:ring-1 focus:ring-blue-500 bg-white`}
                />
              ))}
            </div>
            <div className="flex items-center justify-center gap-2 text-gray-600 font-medium mt-4">
              {/* <p
                className="text-[12px] text-gray-400 general-sans-medium"
                style={{ wordSpacing: "2px" }}
              >
                Resend OTP in
              </p>
              <div className="flex items-center gap-1">
                <Clock size={12} className="text-blue-500" />
                <p className="text-[14px] text-blue-500">{seconds}</p>
              </div> */}
              {seconds > 0 ? (
                <>
                  <p
                    className="text-[12px] text-gray-400 general-sans-medium"
                    style={{ wordSpacing: "2px" }}
                  >
                    Resend OTP in
                  </p>
                  <div className="flex items-center gap-1">
                    <Clock size={12} className="text-blue-500" />
                    <p className="text-[14px] text-blue-500">{seconds}</p>
                  </div>
                </>
              ) : (
                <button
                  className="text-blue-600 text-[14px] font-semibold"
                  onClick={() => sendOtp(value)}
                >
                  Resend OTP
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {error && (
        <p className="text-red-500 text-center text-[14px] general-sans-medium mt-4">
          {error}
        </p>
      )}
    </div>
  );
};

export default AccountLogin;
